export default "/images/blog.webp?677f20bc83ab4ec4eb9ac29c5d94d752";